export default "__VITE_ASSET__CH7C87TU__"